import baseApi from 'api/baseApi';
import { IRequestOptions } from 'common/interfaces/dictionary';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IReqMarkReadParams, IUserNotification } from 'interfaces/userNotification.interfaces';
import { TagType } from 'common/enums/api.enums';

const userNotificationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getUserNotifications: builder.query<IPaginatedData<IUserNotification>, IRequestOptions | void>({
      query: (params = {}) => ({
        url: '/api/v1/employees/notifications',
        method: 'GET',
        params: {
          ...params,
          active: true,
          validityPeriod: 30,
        },
      }),
      providesTags: [TagType.UserNotifications],
    }),
    getUserNotificationsCount: builder.query<number, void>({
      query: () => ({
        url: '/api/v1/employees/notifications/count',
        method: 'GET',
        params: {
          active: true,
          validityPeriod: 30,
        },
      }),
      providesTags: [TagType.UserNotificationsCount],
    }),
    readUserNotification: builder.mutation<void, IReqMarkReadParams>({
      query: params => ({
        url: `/api/v1/employees/notifications/${params.uuid}/read`,
        method: 'PUT',
        data: {
          read: params.read,
        },
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.UserNotifications, TagType.UserNotificationsCount] : [];
      },
    }),
    readUserNotifications: builder.mutation<void, void>({
      query: () => ({
        url: '/api/v1/employees/notifications/read',
        method: 'PUT',
        data: {
          read: true,
        },
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.UserNotifications, TagType.UserNotificationsCount] : [];
      },
    }),
  }),
});

export const {
  useGetUserNotificationsQuery: useGetUserNotifications,
  useGetUserNotificationsCountQuery: useGetUserNotificationsCount,
  useReadUserNotificationMutation: useReadUserNotification,
  useReadUserNotificationsMutation: useReadUserNotifications,
} = userNotificationApi;

export default userNotificationApi;
